export const stickyHeadersDocumentList = {
  score: {
    id: 'score_total_capped',
    label: 'Score',
    class: 'score',
    downArrowDirection: 'asc',
    sortable: true,
  },
  title: {
    id: 'title',
    label: 'Title',
    class: 'title',
    downArrowDirection: 'asc',
    sortable: true,
  },
  lastEdited: {
    id: 'revision_modified_at',
    label: 'Last Edited',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  daysLive: {
    id: 'days_published',
    label: 'Days Live',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  unpublished: {
    id: 'unpublished_at',
    label: 'Unpublished',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  created: {
    id: 'created_at',
    label: 'Created',
    class: 'date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  reqId: {
    id: 'ats_requisition_id',
    label: 'Req ID',
    class: 'ats-req-id',
    downArrowDirection: 'asc',
    sortable: true,
  },
  location: {
    id: 'location',
    label: 'Location',
    class: 'location',
    downArrowDirection: 'asc',
    sortable: true,
  },
  metadata: {
    id: 'ats_requisition_id',
    label: 'Metadata',
    class: 'ats-req-id',
    downArrowDirection: 'asc',
    sortable: true,
  },
  department: {
    id: 'ats_department_name',
    label: 'Department',
    class: 'department',
    downArrowDirection: 'asc',
    sortable: true,
  },
  visibility: {
    id: 'is_hidden',
    label: 'Visibility',
    class: 'flagship-visibility',
    downArrowDirection: 'asc',
    sortable: true,
  },
  createdIn: {
    id: 'platform',
    label: 'Created In',
    class: 'platform',
    downArrowDirection: 'asc',
    sortable: true,
  },
};

export const stickyHeadersTemplates = {
  score: {
    id: 'score',
    label: 'Score',
    class: 'score',
    downArrowDirection: 'asc',
    sortable: true,
  },
  name: {
    id: 'title',
    label: 'Name',
    class: 'name-header',
    downArrowDirection: 'asc',
    sortable: true,
  },
  createdBy: {
    id: 'created_by',
    label: 'Created By',
    class: 'created-by',
    downArrowDirection: 'asc',
    sortable: true,
  },
  createdDate: {
    id: 'created_at',
    label: 'Created Date',
    class: 'created-date',
    downArrowDirection: 'desc',
    sortable: true,
  },
  lastEdited: {
    id: 'last_edited',
    label: 'Last Edited',
    class: 'last-edited',
    downArrowDirection: 'desc',
    sortable: true,
  },
  status: {
    id: 'is_hidden',
    label: 'Visibility',
    class: 'status',
    downArrowDirection: 'desc',
    sortable: true,
  },
};

export const stickyHeadersRequisitions = {
  title: {
    id: 'title',
    label: 'Requisition Name',
    class: 'req-name',
    downArrowDirection: 'asc',
    sortable: false,
  },
  reqId: {
    id: 'ats_requisition_label',
    label: 'Req ID',
    class: 'req-id',
    downArrowDirection: 'asc',
    sortable: false,
  },
  livePosts: {
    id: 'published_job_posts',
    label: 'Live Posts',
    class: 'count',
    downArrowDirection: 'asc',
    sortable: false,
  },
  totalPosts: {
    id: 'total_job_posts',
    label: 'Total Posts',
    class: 'count',
    downArrowDirection: 'asc',
    sortable: false,
  },
  activeApps: {
    id: 'active_applicants',
    label: 'Active Apps',
    class: 'count applicants',
    downArrowDirection: 'asc',
    sortable: false,
  },
  totalApps: {
    id: 'total_applicants',
    label: 'Total Apps',
    class: 'count applicants',
    downArrowDirection: 'asc',
    sortable: false,
  },
  closedAt: {
    id: 'closed_at',
    label: 'Closed',
    class: 'closed-at',
    downArrowDirection: 'desc',
    sortable: false,
  },
  daysOpen: {
    id: 'opened_at',
    label: 'Days Open',
    class: 'count',
    downArrowDirection: 'desc',
    sortable: false,
  },
  department: {
    id: 'department_name',
    label: 'Department',
    class: 'department',
    downArrowDirection: 'asc',
    sortable: false,
  },
  hiringManager: {
    id: 'hiring_managers',
    label: 'Hiring Manager',
    class: 'hiring-manager',
    sortable: false,
  },
};

export const stickyHeadersEmployees = {
  select: {
    id: '__select',
    label: '',
    class: 'select',
    sortable: false,
  },
  employee: {
    id: 'first_name',
    label: 'Employee',
    class: 'employee',
    downArrowDirection: 'asc',
    sortable: true,
  },
  jobProfile: {
    id: 'job_profile_title',
    label: 'Current Job Profile',
    class: 'job-profile',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: {
      key: 'acknowledgement-header-profile',
    },
  },
  acknowledgementStatus: {
    id: 'acknowledgement_alert',
    label: 'Current Acknowledgement',
    class: 'acknowledgement-status',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: {
      key: 'acknowledgement-header-current-ack',
    },
  },
  daysSinceLastAcknowledgement: {
    id: 'days_since_last_signed',
    label: 'Days Since Last Signed',
    class: 'days-since',
    downArrowDirection: 'desc',
    sortable: true,
    tooltip: {
      key: 'acknowledgement-header-last-signed',
    },
  },
  action: {
    id: 'action',
    label: 'Action',
    class: 'action',
    sortable: false,
  },
  view: {
    id: 'view',
    label: 'View',
    class: 'view',
    sortable: false,
  },
};

export const stickyHeadersJobProfiles = {
  select: {
    id: '__select',
    label: '',
    class: 'select',
    sortable: false,
  },
  title: {
    id: 'title',
    label: 'Title',
    class: 'profile-title',
    sortable: true,
  },
  jobCode: {
    id: 'job_code',
    label: 'Job Code',
    class: 'job-code',
    sortable: false,
  },
  jobFamily: {
    id: 'job_family',
    label: 'Job Family',
    class: 'job-family',
    sortable: false,
  },
  level: {
    id: 'level',
    label: 'Job Level',
    class: 'level',
    sortable: false,
  },
  status: {
    id: 'status',
    label: 'Status',
    class: 'status',
    sortable: false,
  },
  effectiveOn: {
    id: 'effective_date',
    label: 'Effective On',
    class: 'effective-on',
    sortable: true,
  },
  department: {
    id: 'department',
    label: 'Department',
    class: 'department',
    sortable: false,
  },
  lastRevised: {
    id: 'created_at',
    label: 'Last Revised',
    class: 'last-revised',
    sortable: true,
  },
  language: {
    id: 'language',
    label: 'Language',
    class: 'language',
    sortable: false,
  },
  notes: {
    id: 'notes',
    label: 'When to use this template',
    class: 'notes',
    sortable: false,
  },
};

export const stickyHeadersApprovals = {
  jobProfile: {
    id: 'title',
    label: 'Job Profile',
    class: 'job-profile',
    sortable: false,
  },
  status: {
    id: 'status',
    label: 'Status',
    class: 'status',
    sortable: false,
  },
  stages: {
    id: 'current_stage',
    label: 'Stages',
    class: 'stages',
    sortable: false,
  },
  createdBy: {
    id: 'created_by',
    label: 'Created By',
    class: 'created-by',
    sortable: false,
  },
  days: {
    id: 'days',
    label: 'Days',
    class: 'days',
    sortable: false,
    tooltip: { key: 'approvals-dashboard-days' },
  },
  actions: {
    id: 'actions',
    label: 'Actions',
    class: 'actions',
    sortable: false,
  },
};

export const stickyHeadersFlsaSurveys = {
  jobProfile: {
    id: 'title',
    label: 'Job Profile',
    class: 'job-profile',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: { key: 'flsa-report-profile' },
  },
  jobLevel: {
    id: 'job_level',
    label: 'Job Level',
    class: 'job-level',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: { key: 'flsa-report-job-level' },
  },
  formSubmittedBy: {
    id: 'form_submitted_by',
    label: 'Form Submitted By',
    class: 'form-submitted-by',
    sortable: false,
    tooltip: { key: 'flsa-report-form-submitted-by' },
  },
  flsaStatus: {
    id: 'latest_submission_exempt_status',
    label: 'FLSA Form Status',
    class: 'flsa-status',
    downArrowDirection: 'asc',
    sortable: true,
    tooltip: { key: 'flsa-report-flsa-status' },
  },
  exemptionBasis: {
    id: 'exemption_basis',
    label: 'Exemption Basis',
    class: 'exemption-basis',
    sortable: false,
    tooltip: { key: 'flsa-report-exemption-basis' },
  },
  alerts: {
    id: 'alerts',
    label: 'FLSA Status Alerts',
    class: 'alerts',
    downArrowDirection: 'asc',
    sortable: false,
    tooltip: { key: 'flsa-report-alerts' },
  },
};

export const getStickyHeaderSortColumnLabel = (sortId, stickyHeaders) => {
  const baseId = sortId.startsWith('-') ? sortId.slice(1) : sortId;
  const column = Object.values(stickyHeaders).find((item) => item.id === baseId);

  return column?.label || baseId;
};
